// src/pages/ProGestao.js
import React, { useEffect, useState } from "react";
import "leaflet/dist/leaflet.css";

// Subindo um nível (../) para acessar as pastas de hooks e componentes
// import { useLogin } from "../hooks/useLogin";
import { useNucleoFilters } from "../hooks/useNucleoFilters_progestao";
import MapComponent from "../components/progestao_compopnents/MapComponentProgestao";
import FilterControls from "../components/progestao_compopnents/FilterControlsProgestao";
import ViewSwitcher from '../components/progestao_compopnents/ViewSwitcherProgestao';
import PainelPrincipal from '../components/progestao_compopnents/PainelPrincipalProgestao';

import { useAuth } from "../context/AuthContext";

// Verifique se este caminho está correto conforme sua nova pasta de componentes de progestão
import ChartsProGestaoReduzido from '../components/progestao_compopnents/ChartsProGestaoReduzido';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

import '../App.css';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

// MUDANÇA: 'progestao' para 'ProGestao' (Letra Maiúscula)
function ProGestao() {
  const { user, logout } = useAuth();
  const username = user?.username || user?.nome;

  const [selectedTerritorio, setSelectedTerritorio] = useState("Todos");
  const [selectedMunicipio, setSelectedMunicipio] = useState("Todos");
  const [selectedNucleo, setSelectedNucleo] = useState("Todos");
  const [showCharts] = useState(true);
  const [activeView, setActiveView] = useState('painel1');
  const [selectedUnidade, setSelectedUnidade] = useState("Todos");


    
    useEffect(() => {
        setMapKey(prevKey => prevKey + 1);
    }, [selectedTerritorio, selectedMunicipio, selectedNucleo, selectedUnidade]);

    useEffect(() => {
        setSelectedMunicipio("Todos");
        setSelectedNucleo("Todos");
        setSelectedUnidade("Todos"); // Adicionado reset
    }, [selectedTerritorio]);

    useEffect(() => {
        setSelectedNucleo("Todos");
        setSelectedUnidade("Todos"); // Adicionado reset
    }, [selectedMunicipio]);

    useEffect(() => {
        setSelectedNucleo("Todos");
        setSelectedUnidade("Todos"); // Adicionado reset ao trocar painel
    }, [activeView]);




    const [layersVisibility, setLayersVisibility] = useState({
        lotes: true,
        quadras: true,
        nucleos: true,
        municipios: true,
        territorios: true,
        unidades: true
    });


    const {
        municipiosMap,
        territorios,
        territoriosOptions,
        municipiosFiltrados,
        unidadesOptions, 
        filteredBounds,
        


        progestaoData, 
        loading: loadingPainel1,


    } = useNucleoFilters(selectedTerritorio, selectedMunicipio, selectedNucleo,selectedUnidade,activeView);

    
    const isAppLoading = loadingPainel1  ;


    
    const [mapKey, setMapKey] = useState(0);
    const boundsKey = `${activeView}-${selectedTerritorio}-${selectedMunicipio}-${selectedNucleo}-${selectedUnidade}`;
    
    useEffect(() => {
        // Incrementa mapKey para recriar o MapContainer apenas em casos críticos de redimensionamento
        // Para movimentos de câmera, usamos a prop boundsKey internamente no componente
        setMapKey(prevKey => prevKey + 1);
    }, [showCharts]);
    
  // if (!isLoggedIn) return <LoginForm onLogin={login} />;

  return (
    <div className="dashboard" style={{ display: "flex", height: "100vh", width: "100vw", background: "#f5f5f5" }}>
      <div style={{ backgroundColor: "#f5f5f5", padding: "10px", display: "flex", gap: "10px", borderRight: "1px solid #ddd" }}>
        <div style={{ display: "flex", flexDirection: "column", maxWidth: "600px" }}>
          <FilterControls
            username={username}
            handleLogout={logout}
            selectedTerritorio={selectedTerritorio}
            setSelectedTerritorio={setSelectedTerritorio}
            territoriosOptions={territoriosOptions}
            selectedMunicipio={selectedMunicipio}
            setSelectedMunicipio={setSelectedMunicipio}
            municipiosFiltrados={municipiosFiltrados}

            setSelectedNucleo={setSelectedNucleo}
            activeView={activeView}
            selectedUnidade={selectedUnidade}
            setSelectedUnidade={setSelectedUnidade}
            unidadesOptions={unidadesOptions}
            progestaoData={progestaoData}
            layersVisibility={layersVisibility}
            setLayersVisibility={setLayersVisibility}
          />
          
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            <div style={{ width: "450px", background: "#fff", padding: 4, marginTop: 12, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
              {isAppLoading ? (
                <p style={{ fontSize: 14, color: "#888", height: "200px" }}>Carregando dados...</p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <ViewSwitcher activeView={activeView} setActiveView={setActiveView} />
                  {activeView === 'painel1' && (
                    <PainelPrincipal
                      loading={isAppLoading}
                      progestaoData={progestaoData}
                      resumoProgestao={progestaoData}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ width: showCharts ? 520 : 20, height: "100vh", transition: "width 0.3s ease", display: "flex", flexDirection: "row" }}>
          {showCharts && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr", alignContent: "top", width: "100%" }}>
              {activeView === 'painel1' && (
                <div style={{ width: "100%" }}>
                  <ChartsProGestaoReduzido data={progestaoData} loading={isAppLoading} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: "flex", flex: 1, padding: 20, borderRadius: 8, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
        <MapComponent
          key={`map-${mapKey}`}
          boundsKey={boundsKey}
          territorios={territorios}
          municipios={municipiosMap}
          bounds={filteredBounds}
          layers={layersVisibility}
          progestaoData={progestaoData}
        />
      </div>
    </div>
  );
}

export default ProGestao;